import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Dashboard from "./components/Dashboard";
import Cards from "./components/Cards";


import Earnings from "./components/Earnings"; // ✅ FIXED
import Admin from "./components/Admin"; // ✅ NEW
import Home from "./components/Home";

import Withdraw from "./components/Withdraw";


function RoutesFile() {
  return (
    <Router>

      {/* 🌟 BACKGROUND GLOW */}
      <div className="fixed left-[-100px] top-1/4 w-[300px] h-[300px] rounded-full pointer-events-none z-0
        bg-gradient-to-br from-[#d4af37] to-[#b8860b] opacity-40 blur-[180px]" />

      <div className="fixed right-[-100px] top-1/3 w-[300px] h-[300px] rounded-full pointer-events-none z-0
        bg-gradient-to-br from-[#b8860b] to-[#d4af37] opacity-40 blur-[180px]" />

      {/* MAIN WRAPPER */}
      <div className="relative z-10 min-h-screen flex flex-col bg-black text-white">

        <Navbar />

        <div className="flex-1 w-full max-w-[1400px] mx-auto px-4 py-6">

          <Routes>

            <Route path="/" element={<Home />} />
           <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/Cards" element={<Cards />} />
           
            <Route path="/earnings" element={<Earnings />} /> 

            <Route path="/withdraw" element={<Withdraw />} />


            {/* 🔥 ADMIN ROUTE */}
            <Route path="/admin" element={<Admin />} />

          </Routes>

        </div>

        <Footer />

      </div>

    </Router>
  );
}

export default RoutesFile;